import React, { useState } from "react";
import { Button, Form, Modal, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getSettings, uploadFileInChat } from "../../reducers/commonReducer";
import { parseBannerSlides } from "../../helpers/bannerSlides";

function BannerSliderManager({
  api,
  title,
  btnTitle,
  name,
  halptext,
  filter,
  settingKey,
  id,
  value,
  status,
}) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [slides, setSlides] = useState([]);
  const [slideStatus, setSlideStatus] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleShow = () => {
    setSlides(parseBannerSlides(value));
    setSlideStatus(typeof status === "boolean" ? status : true);
    setShow(true);
  };
  const handleClose = () => setShow(false);

  const handleAddSlide = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;

    setUploading(true);
    const uploadResp = await dispatch(uploadFileInChat({ fileupload: [file] }));
    const cloudUrl = uploadResp?.payload?.uploads?.[0]?.cloudUrl;
    if (cloudUrl) {
      setSlides((prev) => [...prev, { image: cloudUrl, link: "" }]);
    }
    setUploading(false);
  };

  const handleRemoveSlide = (index) => {
    setSlides((prev) => prev.filter((_, i) => i !== index));
  };

  const handleLinkChange = (index, link) => {
    setSlides((prev) =>
      prev.map((slide, i) => (i === index ? { ...slide, link } : slide))
    );
  };

  const handleMoveSlide = (index, direction) => {
    setSlides((prev) => {
      const nextIndex = index + direction;
      if (nextIndex < 0 || nextIndex >= prev.length) return prev;
      const next = [...prev];
      [next[index], next[nextIndex]] = [next[nextIndex], next[index]];
      return next;
    });
  };

  const handleSubmit = async () => {
    setSaving(true);
    const payload = {
      id,
      key: settingKey,
      name,
      halptext,
      filter,
      linkUrl: "",
      value: JSON.stringify(slides),
      status: slideStatus,
    };

    const apiResp = await dispatch(api(payload));
    if (apiResp?.payload?.status) {
      handleClose();
      dispatch(getSettings());
    }
    setSaving(false);
  };

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        {btnTitle || <i className="bi bi-pencil-square"></i>}
      </Button>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted">
            Add one or more images. Customers will see them rotate as a slider,
            in the order shown below.
          </p>

          {slides.length === 0 && (
            <p className="text-muted">No slides added yet.</p>
          )}

          {slides.map((slide, index) => (
            <Row
              key={`${slide.image}-${index}`}
              className="align-items-center mb-3 border-bottom pb-2"
            >
              <Col xs={3}>
                <img
                  src={slide.image}
                  alt={`Slide ${index + 1}`}
                  className="setting-slide-thumb"
                />
              </Col>
              <Col xs={6}>
                <Form.Control
                  type="url"
                  placeholder="https://example.com (optional link)"
                  value={slide.link}
                  onChange={(e) => handleLinkChange(index, e.target.value)}
                />
              </Col>
              <Col xs={3} className="d-flex gap-1">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  disabled={index === 0}
                  onClick={() => handleMoveSlide(index, -1)}
                >
                  <i className="bi bi-arrow-up"></i>
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  disabled={index === slides.length - 1}
                  onClick={() => handleMoveSlide(index, 1)}
                >
                  <i className="bi bi-arrow-down"></i>
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleRemoveSlide(index)}
                >
                  <i className="bi bi-trash"></i>
                </Button>
              </Col>
            </Row>
          ))}

          <Form.Group className="mb-3">
            <Form.Label>Add Slide Image</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={handleAddSlide}
              disabled={uploading}
            />
            {uploading && (
              <Form.Text className="text-muted">Uploading...</Form.Text>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              value={slideStatus}
              onChange={(e) => setSlideStatus(e.target.value === "true")}
            >
              <option value={true}>Active</option>
              <option value={false}>InActive</option>
            </Form.Control>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            onClick={handleSubmit}
            disabled={saving || uploading}
          >
            {saving ? "Saving..." : "Submit"}
          </Button>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BannerSliderManager;
